const isImageValid = (url: string): boolean => {
	const isSVG = url.endsWith('.svg')
	const isPNG = url.endsWith('.png')
	const isJPEG = url.endsWith('.jpg') || url.endsWith('.jpeg')
	const hasValidExtension = isPNG || isJPEG || isSVG
	return hasValidExtension
}

export { isImageValid }
